import { signInWithEmail, signUpWithEmail, signInWithGoogle, resetPassword, sendVerification } from '../../src/auth.js';
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from '../../src/firebase.js';

export class Login {
    constructor(containerId) {
        this.containerId = containerId;
        this.isSignUp = false;
    }

    init() {
        const container = document.getElementById(this.containerId);
        if (!container) return;

        this.render(container);
    }

    render(container) {
        const title = this.isSignUp ? 'Create an Account' : 'Welcome Back';
        const btnText = this.isSignUp ? 'Sign Up' : 'Sign In';
        const toggleText = this.isSignUp ? 'Already have an account?' : "Don't have an account?";
        const toggleLink = this.isSignUp ? 'Sign In' : 'Sign Up';

        container.innerHTML = `
            <div style="display: flex; align-items: center; justify-content: center; min-height: calc(100vh - 100px); width: 100%; padding: 20px; box-sizing: border-box;">
            <div style="width: 100%; max-width: 400px; padding: 30px; background: #fff; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.08); text-align: center;">
                <img src="/images/logo2.png" alt="FootballGirl" style="width: 80px; margin-bottom: 20px; display: block; margin-left: auto; margin-right: auto;">
                
                <h2 style="margin: 0 0 20px 0; font-size: 24px; font-weight: 600;">${title}</h2>
                <div id="login-view">
                <form id="fg-auth-form" style="display: flex; flex-direction: column; gap: 15px; text-align: left;">
                    <div>
                        <label style="font-size: 14px; font-weight: 600; margin-bottom: 8px; display: block;">Email</label>
                        <input type="email" id="auth-email" required style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 6px; box-sizing: border-box; font-size: 16px;">
                    </div>
                    
                    <div>
                        <label style="font-size: 14px; font-weight: 600; margin-bottom: 8px; display: block;">Password</label>
                        <input type="password" id="auth-password" required style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 6px; box-sizing: border-box; font-size: 16px;">
                    </div>

                    <button type="submit" class="fg-btn fg-btn--primary" style="width: 100%; justify-content: center; margin-top: 10px; padding: 10px 12px; font-size: 16px; border: none; border-radius: 6px; cursor: pointer; font-weight: 600;">
                        ${btnText}
                    </button>
                </form>
                
                <div style="text-align: right; margin-top: 10px; display: ${this.isSignUp ? 'none' : 'block'}">
                    <a href="#" id="forgot-password-link" style="color: #007bff; text-decoration: none; font-size: 13px;">Forgot password?</a>
                </div>

                <div style="margin: 20px 0; position: relative;">
                    <hr style="border: 0; border-top: 1px solid #eee; margin: 0;">
                    <span style="position: absolute; top: -10px; left: 50%; transform: translateX(-50%); background: #fff; padding: 0 10px; color: #888; font-size: 12px;">OR</span>
                </div>

                <button type="button" id="auth-google" class="fg-btn" style="width: 100%; justify-content: center; background: #fff; border: 1px solid #ddd; color: #333; padding: 10px 12px; font-size: 16px; border-radius: 6px; cursor: pointer; display: flex; align-items: center; gap: 10px;">
                    <svg viewBox="0 0 24 24" style="width: 18px; height: 18px; flex-shrink: 0;"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
                    <span>Sign in with Google</span>
                </button>

                <p style="margin-top: 25px; font-size: 14px;">
                    ${toggleText} <a href="#" id="auth-toggle" style="color: #007bff; text-decoration: none; font-weight: 600;">${toggleLink}</a>
                </p>
                </div>

                <!-- Forgot Password View -->
                <div id="forgot-password-view" style="display: none; text-align: left;">
                    <h3 style="margin: 0 0 15px 0; font-weight: 600; font-size: 18px;">Reset Password</h3>
                    <p style="margin-bottom: 15px; color: #666; font-size: 14px;">Enter your email address and we'll send you a link to reset your password.</p>
                    
                    <form id="fg-reset-form" style="display: flex; flex-direction: column; gap: 15px;">
                        <div>
                            <label style="font-size: 14px; font-weight: 600; margin-bottom: 8px; display: block;">Email</label>
                            <input type="email" id="reset-email" required style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 6px; box-sizing: border-box; font-size: 16px;">
                        </div>
                        <div id="reset-message" style="display: none; font-size: 14px; padding: 10px; border-radius: 6px;"></div>
                        <button type="submit" class="fg-btn fg-btn--primary" style="width: 100%; justify-content: center; padding: 10px 12px; font-size: 16px; border: none; border-radius: 6px; cursor: pointer; font-weight: 600;">Send Reset Email</button>
                    </form>
                    
                    <div style="text-align: center; margin-top: 20px;">
                        <a href="#" id="back-to-login" style="color: #666; text-decoration: none; font-size: 14px;">← Back to Login</a>
                    </div>
                </div>
            </div>
            </div>
        `;

        this.attachEvents(container);
    }

    attachEvents(container) {
        const form = container.querySelector('#fg-auth-form');
        const emailInput = container.querySelector('#auth-email');
        const passInput = container.querySelector('#auth-password');
        const toggleBtn = container.querySelector('#auth-toggle');
        const googleBtn = container.querySelector('#auth-google');
        
        const loginView = container.querySelector('#login-view');
        const forgotView = container.querySelector('#forgot-password-view');
        const forgotLink = container.querySelector('#forgot-password-link');
        const backLink = container.querySelector('#back-to-login');

        // Handle Form Submit (Email/Pass)
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const submitBtn = form.querySelector('button[type="submit"]');
            const email = emailInput.value;
            const password = passInput.value;

            // Disable button and show loading state
            submitBtn.disabled = true;
            const originalBtnText = submitBtn.textContent;
            submitBtn.textContent = 'Processing...';

            try {
                if (this.isSignUp) {
                    let user = await signUpWithEmail(email, password);
                    // Send verification email immediately
                    if (!user) user = auth.currentUser;
                    
                    if (user) {
                        await sendVerification(user);
                    } else {
                        console.warn("User not found after signup, skipping verification");
                    }
                    // On successful signup -> Onboarding
                    if (window.app) window.app.handleNavigation('onboarding');
                } else {
                    await signInWithEmail(email, password);
                    // On successful login -> Redirect or Home
                    const redirectPage = localStorage.getItem('fg_login_redirect') || 'home';
                    localStorage.removeItem('fg_login_redirect');
                    if (window.app) window.app.handleNavigation(redirectPage);
                }
            } catch (error) {
                // Re-enable button on error
                submitBtn.disabled = false;
                submitBtn.textContent = originalBtnText;
                alert(`Error: ${error.message}`);
            }
        });

        // Handle Google Login
        googleBtn.addEventListener('click', async () => {
            googleBtn.disabled = true;
            const originalText = googleBtn.innerHTML;
            googleBtn.textContent = 'Signing in...';

            try {
                const user = await signInWithGoogle();
                
                // Check Firestore for onboarding status
                const userDocRef = doc(db, "users", user.uid); 
                const userDoc = await getDoc(userDocRef);

                if (userDoc.exists() && userDoc.data().onboardingComplete) {
                    // User exists and has completed onboarding -> Redirect or Home
                    const redirectPage = localStorage.getItem('fg_login_redirect') || 'home';
                    localStorage.removeItem('fg_login_redirect');
                    if (window.app) window.app.handleNavigation(redirectPage);
                } else {
                    // Write basic Google data to Firestore for new/incomplete users
                    await setDoc(userDocRef, {
                        displayName: user.displayName,
                        photoURL: user.photoURL,
                        email: user.email,
                        createdAt: serverTimestamp()
                    }, { merge: true });

                    // New user or incomplete onboarding -> Onboarding
                    if (window.app) window.app.handleNavigation('onboarding');
                }
            } catch (error) {
                googleBtn.disabled = false;
                googleBtn.innerHTML = originalText;
                alert(`Google Sign In Error: ${error.message}`);
            }
        });

        // Handle Toggle (Login <-> Signup)
        toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.isSignUp = !this.isSignUp;
            this.render(container);
        });

        // Handle Forgot Password View Toggle
        forgotLink?.addEventListener('click', (e) => {
            e.preventDefault();
            loginView.style.display = 'none';
            forgotView.style.display = 'block';
        });

        backLink?.addEventListener('click', (e) => {
            e.preventDefault();
            forgotView.style.display = 'none';
            loginView.style.display = 'block';
        });

        // Handle Password Reset Submit
        const resetForm = container.querySelector('#fg-reset-form');
        const resetEmailInput = container.querySelector('#reset-email');
        const resetMsg = container.querySelector('#reset-message');

        resetForm?.addEventListener('submit', async (e) => {
            e.preventDefault();
            const email = resetEmailInput.value;
            
            try {
                await resetPassword(email);
                resetMsg.textContent = "Password reset email sent. Check your inbox.";
                resetMsg.style.display = 'block';
                resetMsg.style.backgroundColor = '#d4edda';
                resetMsg.style.color = '#155724';
                resetForm.querySelector('button').disabled = true;
            } catch (error) {
                resetMsg.textContent = error.message;
                resetMsg.style.display = 'block';
                resetMsg.style.backgroundColor = '#f8d7da';
                resetMsg.style.color = '#721c24';
            }
        });
    }
}